// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);
const $ = require('jquery');
require("component-responsive-frame/child");

// function myPlayFunction() {
//     document.getElementById("slideset1").style.WebkitAnimationPlayState = "running"; // Code for Chrome, Safari, and Opera
//     document.getElementById("slideset1").style.animationPlayState = "running";
// }

// function myPauseFunction() {
//     document.getElementById("slideset1").style.WebkitAnimationPlayState = "paused"; // Code for Chrome, Safari, and Opera
//     document.getElementById("slideset1").style.animationPlayState = "paused";
// }

// $(function() {
//     $("#play-button").on("click", function() {
//         myPlayFunction();
//     });
    
//     $("#pause-button").on("click", function() {
//         myPauseFunction();
//     });
// });
